import { v4 as uuidv4 } from 'uuid';

import { IKnmReason248 } from 'APIPackage/KnmModule/interfaces/IKnmReason248';
import { createKnmReasonExtendedSelectOption } from 'CorePackage/CatalogsModule/common/createKnmReasonTypeSelectOption';
import { getDictionarySelectOptionWithState } from 'CorePackage/DictionariesModule/common/getDictionarySelectOptionWithState';
import { DictionaryUUIDsEnum } from 'CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';
import { DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { convertInitialKnmDateToFormDate } from 'KnmPackage/MainModule/common/convertInitialKnmDateToFormDate';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getFullNameGuarantor } from 'KnmPmPackage/PmReasonsModule/common/getFullNameGuarantor';

import { createKnmOrderSelectOption } from '../../../KnmPackage/MainModule/common/createKnmOrderSelectOption';
import { convertKnmDataConditionTypeToFormValue } from '../../../KnmPackage/KnmDocumentsModule/common/convertKnmDataConditionTypeToFormValue';
import { IDecisionFormReason } from '../interfaces/IDecisionFormReason';
import { IDecisionForm } from '../interfaces/IDecisionForm';

interface IConvertInitialReasonsPmToFormDateProps {
  reasons: IKnmReason248[] | null | undefined;
  state: IRootState;
  initialFormValues: IDecisionForm;
}

export const convertInitialReasonsToFormDate = ({
  reasons,
  state,
  initialFormValues,
}: IConvertInitialReasonsPmToFormDateProps): IDecisionFormReason[] | undefined => {
  return reasons?.map((item, index) => {
    const initialReasonType = convertKnmDataConditionTypeToFormValue(state, 'PM', item?.reason);

    return {
      ...item,
      ...initialFormValues.reasons?.[index],
      riskIndicators:
        item.riskIndicators?.map(indicatorValue => {
          const indicatorOption = indicatorValue.riskIndicator?.dictId
            ? getDictionarySelectOptionWithState<typeof DictionaryUUIDsEnum.RISK_INDICATORY>(
                state,
                indicatorValue.riskIndicator?.dictId,
                indicatorValue.riskIndicator?.dictVersionId,
              )
            : undefined;

          return {
            guid: indicatorValue.guid,
            riskIndicator: indicatorOption
              ? { ...indicatorOption, label: indicatorOption.shortTitle || indicatorOption.title }
              : indicatorOption,
            indicatorRiskAuto: indicatorValue.indicatorRiskAuto || undefined,
            indicatorRiskAttachment: indicatorValue.indicatorRiskAttachment || undefined,
            isNew: false,
          };
        }) || undefined,
      type:
        item?.reason && initialReasonType
          ? createKnmReasonExtendedSelectOption(
              item?.reason,
              initialReasonType,
              item?.reason?.flagProfvizit,
              item?.reason?.inspectionResults,
            )
          : undefined,
      text: item?.reason?.text || undefined,
      inspectionResults: item?.reason?.inspectionResults,
      ervkUuid: item.reason?.ervkUuid || undefined,
      title: item.reason?.title || undefined,
      shortTitle: item.reason?.shortTitle || undefined,
      date: convertInitialKnmDateToFormDate(item?.reason?.date, DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS),
      assignmentNumber: item?.reason?.assignmentNumber || undefined,
      assignmentDate: convertInitialKnmDateToFormDate(item?.reason?.assignmentDate, DATE_FORMAT_LONG_FNS),
      requirementDetails: item?.reason?.requirementDetails || undefined,
      fullName: getFullNameGuarantor(item.order?.guarantors[0]),
      dateRequirement:
        convertInitialKnmDateToFormDate(item?.reason?.dateRequirement, DATE_FORMAT_LONG_FNS) || undefined,
      links: item.reason?.links || undefined,
      listId: item?.numGuid || uuidv4(),
      order: item.order ? createKnmOrderSelectOption(item.order) : undefined,
      reason: item.reason,
      lastConductedKnmDate: convertInitialKnmDateToFormDate(item?.reason?.lastConductedKnmDate, DATE_FORMAT_LONG_FNS),
      dateBegin: item.reason?.dateBegin || undefined,
      dateEnd: item.reason?.dateEnd || undefined,
      dateCreate: item.reason?.dateCreate || undefined,
      numGuid: item?.numGuid || uuidv4(),
      programAttachment: item.reason?.programAttachment || undefined,
      prosecutorAttachment: item.reason?.prosecutorAttachment || undefined,
      programNumber: item.reason?.programNumber || undefined,
      prescriptionDate:
        convertInitialKnmDateToFormDate(item?.reason?.prescriptionDate, DATE_FORMAT_LONG_FNS) || undefined,
      prescriptionNumber: item.reason?.prescriptionNumber || undefined,
      indicatorRiskAttachment: item.indicatorRiskAttachment || undefined,
      indicatorRiskAuto: item.indicatorRiskAuto || undefined,
      knmIdLink: item.knmIdLink || undefined,
    };
  });
};
